import { Component, inject, model } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbInputDatepicker } from "@ng-bootstrap/ng-bootstrap";
import { DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { IconModule } from "@spartacus/storefront";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { I18nModule } from "@spartacus/core";

@Component({
  selector: 'sanofi-order-history-datepicker',
  standalone: true,
  imports: [
    NgbInputDatepicker,
    FormsModule,
    DatePipe,
    FaIconComponent,
    IconModule,
    I18nModule
  ],
  templateUrl: './order-history-datepicker.component.html'
})
export class OrderHistoryDatepickerComponent {
  calendar = inject(NgbCalendar);
  formatter = inject(NgbDateParserFormatter);

  fromDate = model<NgbDate | null>(null);
  toDate = model<NgbDate | null>(null);

  hoveredDate: NgbDate | null = null;

  onDateSelection(date: NgbDate) {
    if (!this.fromDate() && !this.toDate()) {
      this.fromDate.set(date);
    } else if (this.fromDate() && !this.toDate() && date && date.after(this.fromDate())) {
      this.toDate.set(date);
    } else {
      this.toDate.set(null);
      this.fromDate.set(date);
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate() && !this.toDate() && this.hoveredDate && date.after(this.fromDate()) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate() && date.after(this.fromDate()) && date.before(this.toDate());
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate()) ||
      (this.toDate() && date.equals(this.toDate())) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isFirstInRange(date: NgbDate) {
    return date.equals(this.fromDate());
  }

  isLastInRange(date: NgbDate) {
    return date.equals(this.toDate());
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  protected readonly faArrowRight = faArrowRight;
  protected readonly faCalendar = faCalendar;
}
